import React, {Component} from 'react';
import axios from 'axios';

export default class CrabGourdJackpotSetting extends Component {
    constructor(props) {
        super(props);

        this.state = {
            jackpotSetting: {},
        }

        this.fetchData = this.fetchData.bind(this);
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData() {
        axios.post(global.config.apiDomain + '/game/crab-gourd/web/get-jackpot-setting')
        .then(res => {
            let data = res.data;
            this.setState({
                jackpotSetting: data.data
            })
        });
    }

    updateJackpotAddedPercent() {
        const value = this.state.jackpotSetting.jackpotAddedPercent;
        
        axios.post(global.config.apiDomain + '/game/crab-gourd/web/update-jackpot-added-percent', JSON.stringify({ value: value }), {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(res => {
            if (res.data.status === 'OK') {
                alert('Cập nhật tỉ lệ tích luỹ jackpot thành công!');
            } else {
                alert('Cập nhật thất bại: ' + res.data.message);
            }
        }).catch(error => {
            console.error('Error updating jackpot added percent:', error);
            alert('Có lỗi xảy ra khi cập nhật tỉ lệ tích luỹ jackpot!');
        });
    }

    updateJackpotRate() {
        const value = this.state.jackpotSetting.jackpotRate;
        
        axios.post(global.config.apiDomain + '/game/crab-gourd/web/update-jackpot-rate', JSON.stringify({ value: value }), {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(res => {
            if (res.data.status === 'OK') {
                alert('Cập nhật tỉ lệ nổ hũ thành công!');
            } else {
                alert('Cập nhật thất bại: ' + res.data.message);
            }
        }).catch(error => {
            console.error('Error updating jackpot rate:', error);
            alert('Có lỗi xảy ra khi cập nhật tỉ lệ nổ hũ!');
        });
    }

    render() {
        const {jackpotSetting} = this.state;

        return (
            <>
                <div id="content">
                    <div className="container-fluid">
                        <h1 className="text-center">Quản lí Jackpot</h1>
                        <div className="row justify-content-center">
                            <div className="col-md-6">
                                <div className="card" style={{
                                    border: 'none',
                                    borderRadius: '12px',
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                                    marginTop: '20px'
                                }}>
                                    <div className="card-body" style={{ padding: '30px' }}>
                                        <div className="form-group">
                                            <label style={{ fontWeight: '600', color: '#2c3e50', marginBottom: '8px' }}>
                                                <i className="fas fa-percentage" style={{ marginRight: '8px', color: '#27ae60' }}></i>
                                                Tỉ lệ tích luỹ jackpot
                                            </label>
                                            <div className="input-group">
                                                <input 
                                                    type="number" 
                                                    className="form-control"
                                                    style={{
                                                        border: '2px solid #e9ecef',
                                                        borderRadius: '4px 0 0 4px',
                                                        padding: '10px 12px',
                                                        fontSize: '14px',
                                                        transition: 'border-color 0.3s ease'
                                                    }}
                                                    onFocus={(e) => {
                                                        e.target.style.borderColor = '#27ae60';
                                                        e.target.style.boxShadow = '0 0 0 0.2rem rgba(39, 174, 96, 0.25)';
                                                    }}
                                                    onBlur={(e) => {
                                                        e.target.style.borderColor = '#e9ecef';
                                                        e.target.style.boxShadow = 'none';
                                                    }}
                                                    value={jackpotSetting.jackpotAddedPercent || 0}
                                                    onChange={(e) => this.setState({
                                                        jackpotSetting: {
                                                            ...jackpotSetting,
                                                            jackpotAddedPercent: parseFloat(e.target.value)
                                                        }
                                                    })}
                                                />
                                                <div className="input-group-append">
                                                    <button 
                                                        className="btn btn-success"
                                                        style={{
                                                            border: 'none',
                                                            borderRadius: '4px',
                                                            padding: '8px 16px',
                                                            fontWeight: '500',
                                                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                                            transition: 'all 0.3s ease',
                                                            height: '35px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            marginLeft: '5px'
                                                        }}
                                                        onMouseOver={(e) => {
                                                            e.target.style.transform = 'translateY(-1px)';
                                                            e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.15)';
                                                        }}
                                                        onMouseOut={(e) => {
                                                            e.target.style.transform = 'translateY(0)';
                                                            e.target.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                                                        }}
                                                        onClick={() => this.updateJackpotAddedPercent()}
                                                    >
                                                        <i className="fas fa-save" style={{ marginRight: '6px' }}></i>
                                                        Cập nhật
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <label style={{ fontWeight: '600', color: '#2c3e50', marginBottom: '8px' }}>
                                                <i className="fas fa-bomb" style={{ marginRight: '8px', color: '#e74c3c' }}></i>
                                                Tỉ lệ nổ hũ
                                            </label>
                                            <div className="input-group">
                                                <input 
                                                    type="number"
                                                    className="form-control" 
                                                    style={{
                                                        border: '2px solid #e9ecef',
                                                        borderRadius: '4px 0 0 4px',
                                                        padding: '10px 12px',
                                                        fontSize: '14px',
                                                        transition: 'border-color 0.3s ease'
                                                    }}
                                                    onFocus={(e) => {
                                                        e.target.style.borderColor = '#3498db';
                                                        e.target.style.boxShadow = '0 0 0 0.2rem rgba(52, 152, 219, 0.25)';
                                                    }}
                                                    onBlur={(e) => {
                                                        e.target.style.borderColor = '#e9ecef';
                                                        e.target.style.boxShadow = 'none';
                                                    }}
                                                    value={jackpotSetting.jackpotRate || 0}
                                                    onChange={(e) => this.setState({
                                                        jackpotSetting: {
                                                            ...jackpotSetting,
                                                            jackpotRate: parseFloat(e.target.value)
                                                        }
                                                    })}
                                                />
                                                <div className="input-group-append">
                                                    <button 
                                                        className="btn btn-info"
                                                        style={{
                                                            border: 'none',
                                                            borderRadius: '4px',
                                                            padding: '8px 16px',
                                                            fontWeight: '500',
                                                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                                            transition: 'all 0.3s ease',
                                                            height: '35px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            marginLeft: '5px'
                                                        }}
                                                        onMouseOver={(e) => {
                                                            e.target.style.transform = 'translateY(-1px)';
                                                            e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.15)';
                                                        }}
                                                        onMouseOut={(e) => {
                                                            e.target.style.transform = 'translateY(0)';
                                                            e.target.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                                                        }}
                                                        onClick={() => this.updateJackpotRate()}
                                                    >
                                                        <i className="fas fa-edit" style={{ marginRight: '6px' }}></i>
                                                        Cập nhật
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}